import React, { useState } from 'react';
import PropTypes from 'prop-types';

/**
 * Reusable Single checkbox component
 * @param {object} props - props object
 * @param {object} props.checkBoxProps - props for checkbox input
 * @param {object} props.option - option to be displayed
 * @param {string} props.option.value - value of option
 * @param {string} props.option.label - label of option
 * @param {array} props.checkedOptions - array of checked options
 * @param {string} props.parentNodeClassNames - class names for parent node
 * @param {object} props.restCheckBoxInputAttribute - rest of the attributes for checkbox input
 * @param {function} props.eventCheckBoxChange - function to be called when checkbox input is changed
 * @returns {element} - checkbox input
 */
function CheckBox({ checkBoxProps, option, eventCheckBoxChange }) {
	// get value and label from option
	const { value, label } = option;

	const {
		checkedOptions,
		parentNodeClassNames,
		inputFieldClassNames,
		labelClassNames,
		...restCheckBoxInputAttribute
	} = checkBoxProps;

	// check if value is in checkedOptions
	const isChecked = checkedOptions.find(
		(checkedOption) => checkedOption === value,
	);

	const [checked, setChecked] = useState(isChecked ?? false);

	// when checkbox input is changed
	const handleCheckBoxChange = (e) => {
		setChecked(e.target.checked);
		eventCheckBoxChange(e);
	};

	return (
		<div className={parentNodeClassNames} data-ischecked={checked}>
			<input
				type='checkbox'
				value={value}
				checked={isChecked === value}
				id={label}
				data-isinputchecked={checked}
				onChange={(e) => handleCheckBoxChange(e)}
				className={inputFieldClassNames}
				{...restCheckBoxInputAttribute}
			/>
			<label htmlFor={label} className={labelClassNames}>
				{label}
			</label>
		</div>
	);
}

CheckBox.propTypes = {
	checkBoxProps: PropTypes.object,
	option: PropTypes.object,
	eventCheckBoxChange: PropTypes.func.isRequired,
};

// CheckBox.defaultProps = {
// 	checkBoxProps: {},
// 	option: {},
// };

export default CheckBox;
